import { toast } from "@/components/ui/use-toast"
import { getErrorMessage } from "./errorMessages"

export const showErrorToast = (error) => {
  const message = getErrorMessage(error)

  toast({
    variant: "destructive",
    title: "Error",
    description: message,
  })
}

export const showSuccessToast = (message) => {
  toast({
    title: "Success",
    description: message,
  })
}
